module.exports = __webpack_public_path__ + "static/media/plus.f841f59f.svg";